export const environment = {
    production: false,
    tag: "UAT",
    environmentBanner: "Test Environment",

    // sdkHostUrl: "https://cds-billers-qe-m-dmz.nfr02dmz.aciworldwide.com",
    // sdkVersion: "1.5.0",
    sdkHostUrl: "https://sandbox-cds.officialpayments.com",
    sdkVersion: "1.6.0",
    apiHistUrl: 'https://sandbox-api.acispeedpay.com',
    apiVersion: "v4",

    authServerBasePth: "https://portalserver-uat.acimobills.com/auth/api",

    auth: "Basic dXNyX2Rpc2J1cnNlbWVudHM6WVNwbHptNWx4MTZPczJYZA==",

    disbursementsBasePath: '/disbursements/api',
    walletronBasePath: '/walletron/api',
    walletronRegions: [
        {region: "uat", baseUrl: "https://uat.walletron.click"}
    ]
};